// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nRF8","newExpiryDate":"styles_newExpiryDate__2nkQv","footer":"styles_footer__3agh7"};